import React from 'react';

const CloseIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="25" viewBox="0 0 21 20" fill="none">
        <path d="M10.5869 1.25C5.71191 1.25 1.83691 5.125 1.83691 10C1.83691 14.875 5.71191 18.75 10.5869 18.75C15.4619 18.75 19.3369 14.875 19.3369 10C19.3369 5.125 15.4619 1.25 10.5869 1.25ZM13.9619 14.375L10.5869 11L7.21191 14.375L6.21191 13.375L9.58691 10L6.21191 6.625L7.21191 5.625L10.5869 9L13.9619 5.625L14.9619 6.625L11.5869 10L14.9619 13.375L13.9619 14.375Z" fill="black"/>
    </svg>
);

export default CloseIcon;